<template>
  <div v-if="visible" class="fixed top-6 left-1/2 -translate-x-1/2 z-[1000] flex items-center justify-center pointer-events-none">
    <div 
      class="bg-white dark:bg-slate-800 rounded-full shadow-2xl border border-gray-100 dark:border-slate-700 py-3 px-6 flex items-center gap-3 animate-in fade-in slide-in-from-top-4 duration-300"
    >
      <div 
        class="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
        :class="bgClass"
      >
        <component :is="icon" :size="14" :class="textClass" />
      </div>
      <span class="text-sm font-bold text-gray-900 dark:text-slate-100">{{ message }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { coreState } from '../../stores/core.js'
import { Check, AlertTriangle, Info, XCircle } from 'lucide-vue-next'

const visible = computed(() => coreState.toast?.visible)
const message = computed(() => coreState.toast?.message)
const type = computed(() => coreState.toast?.type)

const icon = computed(() => {
  switch (type.value) {
    case 'error': return XCircle
    case 'warning': return AlertTriangle
    case 'info': return Info
    default: return Check
  }
})

const bgClass = computed(() => {
  switch (type.value) {
    case 'error': return 'bg-red-100 dark:bg-red-900/30'
    case 'warning': return 'bg-amber-100 dark:bg-amber-900/30'
    case 'info': return 'bg-blue-100 dark:bg-blue-900/30'
    default: return 'bg-green-100 dark:bg-green-900/30'
  }
})

const textClass = computed(() => {
  switch (type.value) {
    case 'error': return 'text-red-600 dark:text-red-400'
    case 'warning': return 'text-amber-600 dark:text-amber-400'
    case 'info': return 'text-blue-600 dark:text-blue-400'
    default: return 'text-green-600 dark:text-green-400'
  }
})
</script>
